module.exports = __webpack_public_path__ + "media/Video 6.3c5056d0.mp4";